/* eslint-disable no-dupe-keys */
export default {
  product: {
    name: '商品',
    // 属性
    prop: {
      sales: '销量',
      title: '商品名称',
      service_provider: '商家',
      tag: '分类',
      product_key: '商品唯一的key',
      market_price: '市场价',
      payment_type: '支付方式',
      shipping_method: '送货方式',
      pickup_location_ids: '提货点',
      content: '正文',
      remark: '温馨提示',
      charging_package: '充电包',
      price: '标价',
      picture: '图片',
      cargo_type: '货物类型',
      inventory_count: '库存',
      total_count: '总量',
      bundle_count: '套装数量',
      status: '状态',
      created_at: '创建时间',
      updated_at: '上架时间',
      saleable: '虚拟商品',
      sale_agent_reward: '代理返现',
      sale_agent: '销售代理',
      sale_agent_qrcode: '专属二维码',
      sort_number: '排序编号',
      coupon: '优惠券',
      saleable_type: '虚拟货物类型',
      max_usable_points: '最大可用积分',
      need_certification_car: '认证车辆',
      each_purchase_limit_count: '每人限购',
      limitation: '条件约束',
      membership: 'VIP月会员',
      group: '集团',
      list_page_visible: '是否商城可视'
    },
    // 列表页字段（search display也重用）
    groups: {
      base_info: '基础信息',
      goods_info: '货物信息',
      photos: '商品图片',
      content: '内容',
      remark: '提示',
      sales_data: '销售数据',
      condition: '约束条件',
      cargo_info: '货物信息',
      logistics_info: '物流信息',
      others: '其他信息'
    },
    // Enum的属性
    list_tabs: {
      all: '全部'
    },
    statuses: {
      pending: '待上架',
      enabled: '已上架',
      disabled: '已下架'
    },
    list_page_visibles: {
      true: '商城可视',
      false: '商城不可视'
    },
    shipping_methods: {
      auto_delivery: '自动发货',
      express_delivery: '快递',
      pickup: '自提'
    },
    saleable_types: {
      charging_package: '充电包',
      coupon: '优惠券',
      membership: 'VIP月会员',
      group: '集团'
    },
    cargo_types: {
      virtual: '虚拟',
      entity: '实物'
    },
    need_certification_cars: { not_required: '不需要', non_commercial: '非营运车辆', commercial: '营运车辆', all_usage: '所有车辆' },
    // Boolean的属性
    // 占位提示
    placeholder: {
      search_keyword: '搜索商品名字',
      input_limit_count: '留空表示不限',
      select_tags: '商品的分类',
      select_ref_sorting_product: '请选择位置对标的商品',
      select_vin_certification_group: '请选择需VIN验证的集团',
      input_product_key: '只能输入字母、数字或下划线组合'
    },
    detail_tags: {
      detail: '基本信息',
      product_orders: '订单记录'
    },
    btn: {
      product_order: '商品订单',
      sale_agent: '销售代理二维码'
    },
    tips: {
      picture_size: '推荐宽高比例为1:1，尺寸为 900x900，< 500KB',
      points_to_money: '每积分等于 0.01元，该商品的最大可用积分可抵扣 {0} 元',
      content_picture: '推荐上传图片尺寸宽度 800像素，<500KB',
      product_key: '可忽略，特殊商品才需要填写，用于查找该商品的标签'
    },
    titles: {
      sorting: '商品排序',
      sale_agent_qrcode: '销售代理二维码'
    },
    labels: {
      current_product: '当前商品',
      sorting_position: '位置',
      ref_product: '对标商品'
    },
    sorting_positions: {
      up: '排前面',
      down: '排后面'
    }
  }
}
